// url.js — safe-return-URL validation (slicer red-team SEC-01 pattern).
//
// Login/LoginCallback redirect to a query-provided returnUrl after OAuth.
// Trusting it blindly is an open redirect: an attacker crafts
// /login?returnUrl=https://evil.com and the authenticated user is sent to
// a hostile origin. Only two shapes are allowed:
//   1. origin-relative paths starting with "/" (but NOT "//host" — that is
//      protocol-relative and escapes the origin);
//   2. absolute URLs whose origin exactly equals window.location.origin.
// Anything else falls back to "/".

const DEFAULT_FALLBACK = '/';

export function isSafeReturnUrl(raw, origin) {
  // Boundary parse: raw is a query parameter (string or null).
  // oxlint-disable-next-line anti-slop/no-runtime-typeof
  if (typeof raw !== 'string' || raw.length === 0 || raw.length > 2048) {
    return false;
  }

  if (raw.startsWith('/') && !raw.startsWith('//')) {
    return true; // origin-relative path
  }

  try {
    // For non-slash values require an EXPLICIT absolute URL: new URL(raw)
    // without a base throws on bare relative strings, so "not a url" and
    // "javascript:alert(1)" cannot sneak through as same-origin resolves.
    const url = new URL(raw);

    return (url.protocol === 'https:' || url.protocol === 'http:') && url.origin === origin;
  } catch {
    return false;
  }
}

export function safeReturnUrl(raw, origin, fallback = DEFAULT_FALLBACK) {
  return isSafeReturnUrl(raw, origin) ? raw : fallback;
}
